(function () {
  let loaded = false;

  function load(src) {
    return new Promise(r => {
      const s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.crossOrigin = 'anonymous';
      s.onload = r;
      s.onerror = r;
      document.head.appendChild(s);
    });
  }

  const all = window.__THIRD_PARTY__ || [];

  // Tracking must load immediately. Delaying it until first interaction loses
  // every visitor who bounces before interacting (regression introduced 18 Jun 2026).
  const NEVER_DELAY = ['facebook.net', 'fbevents'];
  const isTracking = function (src) {
    return NEVER_DELAY.some(function (k) { return src.indexOf(k) !== -1; });
  };

  all.filter(isTracking).forEach(function (src) { load(src); });

  const deferred = all.filter(function (src) { return !isTracking(src); });

  async function start() {
    if (loaded) return;
    loaded = true;
    for (const src of deferred) {
      try { await load(src); } catch (e) {}
    }
  }

  ['click','scroll','touchstart','mousemove','keydown'].forEach(e =>
    window.addEventListener(e, start, { once:true, passive:true })
  );

  // Safety fallback
  setTimeout(start, 4000);
})();